export const fr: Record<string, string> = {
  'link.noDescription': 'Aucune description disponible.',
  'link.editRefinementNotes': 'Modifier les notes d’affinage',
  'link.addRefinementNotes': 'Ajouter des notes d’affinage',
  'link.showDescription': 'Afficher la description',
  'link.capabilities': 'Capacités',
  'link.csvEmpty': 'Le fichier CSV est vide ou ne contient aucune ligne de données.',
  'link.importComplete': 'Importation terminée : {imported} liens importés, {skipped} ignorés.',
  'link.importFailed': 'Échec de l’importation : {msg}',
  'link.noCapabilitiesTitle': 'Aucune capacité disponible',
  'link.noCapabilitiesDesc': 'Importez des capacités dans la configuration du tableau de bord pour commencer à associer des ressources.',
  'link.selectCapability': 'Sélectionnez une capacité dans la barre latérale',
  'link.resourceLinked': '{n} ressource associée',
  'link.resourcesLinked': '{n} ressources associées',
  'link.completed': 'Terminé',
  'link.aggregate': 'Vue agrégée',
  'link.filterResources': 'Filtrer les ressources…',
  'link.contributorsLabel': 'Contributeurs :',
  'link.contributorsHelp': 'Les ressources indiquent qui les a associées dans l’équipe.',
  'link.addResourceTitle': 'Ajouter une nouvelle ressource',
  'link.labelTitle': 'Titre *',
  'link.labelType': 'Type *',
  'link.labelFunction': 'Fonction *',
  'link.selectFunction': 'Sélectionnez une fonction...',
  'link.labelDescription': 'Description',
  'link.createAndLink': 'Créer et associer',
  'link.refinementNotesTitle': 'Notes d’affinage — {title}',
  'link.notesPlaceholder': 'Ajoutez des notes sur la manière dont cette ressource contribue à la capacité...',
  'link.saving': 'Enregistrement...',
  'link.overwriteTitle': 'Écraser les liens existants ?',
  'link.overwriteBody1': 'Vous avez actuellement des ressources associées. L’importation de ce CSV va ',
  'link.overwriteBodyStrong': 'remplacer tous vos liens existants',
  'link.overwriteBody2': ' par les {n} liens du fichier.',
  'link.overwriteWarning': 'Cette action est irréversible. Pensez à exporter vos liens actuels au préalable.',
  'link.overwriteImport': 'Écraser et importer',
};

export const en: Record<string, string> = {
  'link.noDescription': 'No description available.',
  'link.editRefinementNotes': 'Edit refinement notes',
  'link.addRefinementNotes': 'Add refinement notes',
  'link.showDescription': 'Show description',
  'link.capabilities': 'Capabilities',
  'link.csvEmpty': 'CSV file is empty or has no data rows.',
  'link.importComplete': 'Import complete: {imported} links imported, {skipped} skipped.',
  'link.importFailed': 'Import failed: {msg}',
  'link.noCapabilitiesTitle': 'No capabilities available',
  'link.noCapabilitiesDesc': 'Upload capabilities in the Dashboard setup to begin linking resources.',
  'link.selectCapability': 'Select a capability from the sidebar',
  'link.resourceLinked': '{n} resource linked',
  'link.resourcesLinked': '{n} resources linked',
  'link.completed': 'Completed',
  'link.aggregate': 'Aggregate',
  'link.filterResources': 'Filter resources…',
  'link.contributorsLabel': 'Contributors:',
  'link.contributorsHelp': 'Resources show who has linked them in the team.',
  'link.addResourceTitle': 'Add New Resource',
  'link.labelTitle': 'Title *',
  'link.labelType': 'Type *',
  'link.labelFunction': 'Function *',
  'link.selectFunction': 'Select a function...',
  'link.labelDescription': 'Description',
  'link.createAndLink': 'Create & Link',
  'link.refinementNotesTitle': 'Refinement Notes — {title}',
  'link.notesPlaceholder': 'Add any notes about how this resource contributes to the capability...',
  'link.saving': 'Saving...',
  'link.overwriteTitle': 'Overwrite existing links?',
  'link.overwriteBody1': 'You currently have linked resources. Uploading this CSV will ',
  'link.overwriteBodyStrong': 'replace all your existing links',
  'link.overwriteBody2': ' with the {n} links from the file.',
  'link.overwriteWarning': 'This action cannot be undone. Consider exporting your current links first.',
  'link.overwriteImport': 'Overwrite & Import',
};
